const auctionStatuses = {
  ACTIVE: "active",
  SCHEDULED: "scheduled",
  FINISHED: "finished",
  CANCELED: "canceled",
};

export default auctionStatuses;
